/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/promql/x-pack-esql/definition/functions/limitk.json`.

import type { PromqlFunctionDefinition } from '../../definition_types';

/**
 * Returns `k` arbitrary elements from the input vector, keeping their full label set. Unlike `topk` and `bottomk`, selection is not sort-based and histogram samples are included.
 *
 * @example
 * limitk(3, http_requests_total)
 */
const definition: PromqlFunctionDefinition = {
  type: 'across_series_reduction',
  name: 'limitk',
  signatures: [
    {
      params: [
        {
          name: 'k',
          type: 'scalar',
          optional: false,
          description: 'Number of series to keep.',
        },
        {
          name: 'v',
          type: 'instant_vector',
          optional: false,
          description: 'Instant vector input.',
        },
      ],
      variadic: false,
      returnType: 'instant_vector',
    },
  ],
  snapshotOnly: false,
};

export default definition;
